import { clientEnvIsIOS } from "./isIOS";
import { clientEnvIsDesktop } from "./isDesktop";

export const clientEnvIsIOSBrowser = (): boolean => {
  return clientEnvIsIOS() && !clientEnvIsDesktop();
};
